// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_JOd","cls2":"utils-cls2_9WW utils-cls1_JOd"};